/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import React from 'react';

interface ICyberColumns {
  showFilters: boolean;
  headers: string[];
  sortData: (key: string) => void;
  sortConfig: { key: string; direction: string };
}

const CyberColumns: React.FC<ICyberColumns> = ({
  showFilters,
  headers,
  sortData,
  sortConfig,
}) => {
  const getSortIcon = (header: string) => {
    if (sortConfig.key !== header) {
      return defaultIcon;
    }

    return sortConfig.direction === 'asc' ? ascIcon : descIcon;
  };

  const defaultIcon = (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        d='M8 12.667V3.333M8 3.333L3.333 8M8 3.333L12.667 8'
        stroke='var(--card-text)'
        strokeWidth='1.333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );

  const ascIcon = defaultIcon;

  const descIcon = (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      fill='none'
      viewBox='0 0 16 16'
    >
      <path
        d='M8 3.333V12.667M8 12.667L3.333 8M8 12.667L12.667 8'
        stroke='var(--card-text)'
        strokeWidth='1.333'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );

  return (
    <div className='screening-results-columns'>
      <div className='screening-table-placeholder-column'></div>
      {headers.map((head, i) => (
        <div
          className='screening-table-title-column'
          key={i}
          onClick={() => sortData(head)}
        >
          <div className='screening-table-title-column-inner'>
            <div className='screening-table-column-text'>
              {head} {getSortIcon(head)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default CyberColumns;
